import { Modal } from "react-bootstrap";

// Shared by Users, Bids History and Won Cars, which each had their own copy.
const ExportModal = ({ state, setState, onExport, loading }) => {
    const close = () => setState((prev) => ({ ...prev, modal: false }));

    return (
        <Modal show={state.modal} onHide={close} centered>
            <Modal.Header closeButton><h5 className="modal-heading">Export Data Limit</h5></Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label htmlFor="export-row-limit">Select Limit</label>
                    {/* The old first option had no value, so picking it sent
                        "Select Limit" to the server as the row limit. */}
                    <select
                        id="export-row-limit"
                        value={state.limit}
                        onChange={(e) => setState((prev) => ({ ...prev, limit: e.target.value }))}
                        className="form-control"
                    >
                        <option value={5000}>All</option>
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                    </select>
                </div>
                <button disabled={loading} style={{ marginLeft: 0, marginTop: "20px" }} onClick={onExport} className="export-button">
                    {loading ? <div className="button-loader"></div> : "Export"}
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default ExportModal;
